<template>
    <div class="mb-1 mb-md-0">
        <font-awesome-icon :icon="icon" class="text-secondary mr-2"/>
        <span class="text-uppercase"><b><span :data-cy="`num${ratingForDataCy()}Ratings`" class="mr-1">{{ count }}</span></b> <b
                class="text-success">{{ rating }}</b> Ratings</span>
    </div>
</template>

<script>
    export default {
        name: "RatingStat",
        props: ["count", "rating", "icon"],
        methods: {
            ratingForDataCy() {
                if (this.rating.startsWith('-')) {
                    return `Negative${this.rating.substring(1, this.rating.length)}`;
                }
                return this.rating;
            }
        },
    }
</script>

<style scoped>

</style>
